import { ZfDialog, ZfDialogContent, ZfDialogHeader, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TopLevelTopicDto } from '../../../api/generated/client';
import { useWindowResize } from '../../../hooks/useWindowResize';
import { TopicDialogGrid } from './TopicDialogGrid';
import { TopicDialogTiles } from './TopicDialogTiles';

interface IProps {
    isOpen: boolean;
    isAddEvent: boolean;
    onClose: () => void;
    onTopicSelected: (topic?: TopLevelTopicDto) => void;
}

export const SelectTopicModal: FunctionComponent<IProps> = ({ isOpen, isAddEvent, onTopicSelected, onClose }) => {
    const { t } = useTranslation();
    const [dialogContentWidth, setDialogContentWidth] = useState(0);

    const handleWindowResize = useCallback(() => {
        setDialogContentWidth((window.innerWidth * 50) / 100);
    }, [setDialogContentWidth]);

    useWindowResize(handleWindowResize, true);

    return (
        <ZfDialog show={isOpen} onDialogClose={onClose} size="m" className="select-topic-modal">
            <ZfDialogHeader>{t(isAddEvent ? 'zfEventModalNewEvent' : 'zfEventModalNewNeed')}</ZfDialogHeader>
            <ZfDialogContent>
                <ZfStack direction="row" justify="center" style={{ flex: 1 }}>
                    <TopicDialogGrid width={dialogContentWidth} aspectRatio={14 / 13}>
                        <TopicDialogTiles
                            width={dialogContentWidth}
                            aspectRatio={14 / 13}
                            onTopicClick={(topic?: TopLevelTopicDto) => onTopicSelected(topic)}
                        />
                    </TopicDialogGrid>
                </ZfStack>
            </ZfDialogContent>
        </ZfDialog>
    );
};
